import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { overload } from "../../shared/src/codecs/types/overload";
import { union } from "../../shared/src/codecs/types/union";
import * as util from "../../shared/src/util";

export const ListingLostReason1 = union([
    literal('not_selling'),
    literal('chose_local_agent'),
    literal('chose_auction'),
    literal('other'),
]);
export type TListingLostReason1 = TTypeOfCodec<typeof ListingLostReason1>;

export const ListingLostReasonDisplayString = overload(
    union([
        literal('Not selling'),
        literal('Chose local agent'),
        literal('Chose auction (third-party)'),
        literal('Other'),
    ]),
    ListingLostReason1,
    (reason) => {
        switch (reason) {
            case "not_selling":
                return "Not selling";
            case "chose_local_agent":
                return "Chose local agent";
            case "chose_auction":
                return "Chose auction (third-party)";
            case "other":
                return "Other";
            default:
                return util.requireExhaustive(reason);
        }
    }
);
export type TListingLostReasonDisplayString = TTypeOfCodec<typeof ListingLostReasonDisplayString>;
